<div id="layout" class="f_col">
  <app-view-title fromRoute="pre-enroll" [chooseLangBtn]="false">{{'selfiePayment.title' | translate}}</app-view-title>
  <div class="scroll_wrapper resp_wrapper">
    <div class="resp_scroll-wrapper_l resp_c-50">
      <app-view-deco-image class="mt_20 mb_20" imageUrl="assets-projects/images/image_webcam.svg"></app-view-deco-image>
      <span class="text_center mb_20"> {{'selfie.desc' | translate}} </span>
      <app-slide-element class="mt_20" leftIcon='camera' (btnClicked)="nav.toPerm('selfie-payment', 'camera-payment', 'CAMERA')">{{'selfie.take' | translate}}</app-slide-element>

      <div class="resp_minSize_l mb_20 mt_20 flex gap_10">
        <app-button size="xsm" color="transparent" border="true" class="fullWidth" (btnClicked)="backClick()">
          {{'global.back' | translate}}
        </app-button>
      </div>
    </div>
  </div>

  <div class="f_align_end mb_20 resp_maxSize_l">
    <app-back-btn class="mr_10" icon="house" [navTo]="{route: 'dashboard'}"></app-back-btn>
    <app-back-btn (btnClicked)="backClick()"></app-back-btn>
  </div>
</div>
